/**
 * Replaces flag emoji with inline images (Windows renders flag emoji as "US", etc.).
 * Config: window.themeVariables.emojiFlags (snippets/js-variables.liquid).
 *
 * @param {string|Element} input - HTML string or DOM root to scan
 * @returns {string|Element}
 */
(function () {
  'use strict';

  var FLAG_EMOJI = ['\uD83C\uDDFA\uD83C\uDDF8', '\uD83C\uDDEA\uD83C\uDDFA', '\uD83C\uDDE6\uD83C\uDDFA'];
  var FLAG_ALT = {
    '\uD83C\uDDFA\uD83C\uDDF8': 'United States',
    '\uD83C\uDDEA\uD83C\uDDFA': 'European Union',
    '\uD83C\uDDE6\uD83C\uDDFA': 'Australia'
  };
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, IMG: 1, NOSCRIPT: 1 };

  function getFlagMap() {
    var cfg = (window.themeVariables && window.themeVariables.emojiFlags) || {};
    return {
      '\uD83C\uDDFA\uD83C\uDDF8': cfg.us,
      '\uD83C\uDDEA\uD83C\uDDFA': cfg.eu,
      '\uD83C\uDDE6\uD83C\uDDFA': cfg.au
    };
  }

  function flagImg(src, alt) {
    if (!src) return '';
    return (
      '<img class="pv-emoji-flag" src="' +
      src +
      '" alt="' +
      alt +
      '" loading="lazy" decoding="async">'
    );
  }

  function containsFlagEmoji(text) {
    for (var i = 0; i < FLAG_EMOJI.length; i++) {
      if (text.indexOf(FLAG_EMOJI[i]) !== -1) return true;
    }
    return false;
  }

  function replaceInString(text) {
    var flags = getFlagMap();
    var out = text;

    FLAG_EMOJI.forEach(function (emoji) {
      var src = flags[emoji];
      if (!src || out.indexOf(emoji) === -1) return;
      out = out.split(emoji).join(flagImg(src, FLAG_ALT[emoji]));
    });

    return out;
  }

  function replaceInElement(root) {
    if (!root || !root.nodeType) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement;
        if (!parent || SKIP_TAGS[parent.tagName]) return NodeFilter.FILTER_REJECT;
        if (parent.closest('.pv-emoji-flag')) return NodeFilter.FILTER_REJECT;
        if (!containsFlagEmoji(node.nodeValue || '')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);

    textNodes.forEach(function (node) {
      var html = replaceInString(node.nodeValue);
      if (html === node.nodeValue) return;

      var wrapper = document.createElement('span');
      wrapper.innerHTML = html;
      node.parentNode.replaceChild(wrapper, node);
    });
  }

  window.pvReplaceEmojiFlags = function (input) {
    if (typeof input === 'string') return replaceInString(input);
    if (input && input.nodeType === 1) {
      replaceInElement(input);
      return input;
    }
    return input;
  };

  document.addEventListener('DOMContentLoaded', function () {
    replaceInElement(document.body);
  });
})();
